export const highscores = [
  {
    id: "666",
    rank: 10,
    username: "sjtgshivam",
    score: 70,
  },
  {
    id: "667",
    rank: 9,
    username: "VermaRajeev",
    score: 60,
  },
  {
    id: "611",
    rank: 8,
    username: "lakshmi67",
    score: 50,
  },
  {
    id: "6155",
    rank: 7,
    username: "snehalSharma",
    score: 87,
  },
  {
    id: "68855",
    rank: 6,
    username: "vikram",
    score: 43,
  },
  {
    id: "78855",
    rank: 5,
    username: "dhruvPandey",
    score: 42,
  },
  {
    id: "788535",
    rank: 4,
    username: "@DeepAggarwal",
    score: 80,
  },
  {
    id: "23112",
    rank: 3,
    username: "Shivansh",
    score: 120,
  },
  {
    id: "13522",
    rank: 2,
    username: "ShivikaRandom",
    score: 130,
  },
  {
    id: "13112",
    rank: 1,
    username: "ArunV",
    score: 140,
  },
];
